import React from 'react';
import useRelationship from 'Hooks/useRelationship';
import fr from 'facet-rest';
import { useDashboardContext } from 'Views/Dashboard/DashboardContext';
import DataContainer from 'Components/UI/DataContainer';
import {
  RoadmapDeliverableReviewRoadmap,
} from 'Views/Dashboard/RoadmapDeliverableDashboardChart/RoadmapDeliverableReviewRoadmap';

const RoadmapDeliverableReviewRoadmapContainer = () => {
  const { clientDashboardResource } = useDashboardContext();
  const {
    isInitializing,
    loadingError,
    collection,
  } = useRelationship(clientDashboardResource.relationship(fr.relationships.householdNextAction.name));

  const resource = collection?.resources().head();

  return (
    <DataContainer
      component={RoadmapDeliverableReviewRoadmap}
      loading={isInitializing}
      componentProps={{
        resource,
      }}
      loadingError={loadingError}
    />
  );
};

export { RoadmapDeliverableReviewRoadmapContainer };
